import React, { useEffect, useState } from "react";
import userRest from "../../rest/userRest";
export const UserContext = React.createContext();

export const UserProvider = props => {

    const [user, setUser] = useState();

    useEffect(() => {
        refresh();
    }, []);

    const refresh = async () => {
        const user = await userRest.getAuthenticatedUser();
        setUser(user);
    };

    const checkFeature = companies => {
        const company = user?.company?.name;
        if (company === "prehcm"){
            return true;
        }
        if (!companies) {
            return true;
        }
        const cs = Array.isArray(companies) ? companies : [companies];
        return company !== undefined && cs.includes(company);
    };

    return (
        <UserContext.Provider value={{
            user,
            refresh,
            checkFeature,
        }}>
            {props.children}
        </UserContext.Provider>
    );
};